import { IBoxComponent } from '@enuan/chat__utils';
import classNames from 'classnames';
import { JSX } from 'react';
import { cleanBoxProps } from '../../../utils/cleanBoxProps';
import { styled } from '@mui/material/styles';
import { fontSecondaryOblique } from 'src/theme/mixins';

export type IFormRowProps = Omit<
	IBoxComponent<JSX.IntrinsicElements['div']>,
	'type'
>;

export const FormRow = styled(
	({
		// custom props
		help_label,
		error,
		error_label,
		label,
		required_label,

		// standard props
		id, //ignore it to avoid duplicate
		className,
		children,
		required,
		action,
		onClick,
		onChange,
		..._props
	}: IFormRowProps) => {
		const props = cleanBoxProps(_props);
		return (
			<div className={classNames('form__row', className)} {...props}>
				{label && (
					<label className={classNames('form__label', 'label', className)}>
						{label}
						{required && <span className="form__required"> *</span>}
					</label>
				)}
				<div className="form__row__input">{children}</div>
				<div className="form__row__extra">
					{help_label && <div className="form__help">{help_label}</div>}
					{required && required_label && (
						<div className="form__required">{required_label}</div>
					)}
					{error && error_label && (
						<label className="form__error">{error_label}</label>
					)}
				</div>
			</div>
		);
	},
	{ target: 'FormRow-root', label: 'FormRow' },
)({
	display: 'flex',
	flexDirection: 'column',
	position: 'relative',

	marginBottom: '1em',
	marginTop: '1em',
	'&:first-child': {
		marginTop: 0,
	},

	'& .form__row__input': {
		margin: '0 10px',
		position: 'relative',
		display: 'flex',
		justifyContent: 'flex-start',
		minHeight: 'calc(0.2em + 1.5em)',
		flexDirection: 'column',
	},
	'& .form__label': {
		marginTop: 0,
		fontFamily: "'Ubuntu', sans-serif",
		color: 'var(--form__element__label_color)',
		textAlign: 'left',
		fontWeight: 'bold',
		display: 'block',
		marginBottom: '0.5em',
		fontSize: '1.6em',
		'&.form__required': {
			margin: 0,
			fontSize: '0.9em',
		},
	},
	'& .form__help': {
		...fontSecondaryOblique,
		fontSize: '1.1em',
		color: 'var(--form__help_color)',
		margin: '10px 0 0',
	},
	'& .form__required': {
		...fontSecondaryOblique,
		fontSize: '1.1em',
		color: 'var(--form__required_color)',
	},
	'& .form__error': {
		...fontSecondaryOblique,
		color: 'var(--form__error_color)',
		fontSize: '1.3em',
	},
});
